import React, { useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";

import { connect } from 'react-redux'
import { getAlljobs, promise } from '../../Action/index'

function DiscriptionJob(props) {
  useEffect(()=>{
    if(props.show.visibility){
    document.body.classList.add("showModal")}
  },[props.show.visibility])
  const kFormatter = (num) => {
    return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'K' : Math.sign(num) * Math.abs(num)
  }
  return (
    <div class={props.show.visibility ? "jblListModal modalHere" : "jblListModal"}>
      <div class="jblListModal_Content">
        <div class="jblListModal_header">
          <span class="close"  onClick={() => {document.body.classList.remove("showModal");props.onHide()}}>&times;</span>
        </div>
        <div class="jblListModal_Body">
          <div class="jblmodal_wrap">
            <div class="jblmodal_border">
              <div class="jblmodal_wrap_img">
                <div class="jblmodal_box">
                  <img src={props.show.data.c_logo} alt="company" class="companyLogo" />
                  <div class="jblmodal_comname_loca">
                    <span class="jblmodal_comp_name">{props.show.data.c_name}</span>
                    <span class="jblmodal_comp_location">{props.show.data.c_location}</span>
                    <p class="Skills"><strong>Skills: </strong>
                    {props.show.data.j_skill&&( props.show.data.j_skill.split(",")).map((item)=>{return(<span>{item}</span>)})}</p>
                  </div>
                </div>
                <a href="#" class="company_mail">{props.show.data.c_email}</a>
              </div>
              <div class="jblmodal_detail">
                <h4>{props.show.data.j_title}</h4>
                <p class="jblmodal_cate"><span>{props.show.data.j_category}</span><span>{props.show.data.j_type}</span></p>
                <span class="jblmodal_expe"><span><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m15 6.5c-.552 0-1-.448-1-1v-1.5h-4v1.5c0 .552-.448 1-1 1s-1-.448-1-1v-1.5c0-1.103.897-2 2-2h4c1.103 0 2 .897 2 2v1.5c0 .552-.448 1-1 1z"></path><path d="m12.71 15.38c-.18.07-.44.12-.71.12s-.53-.05-.77-.14l-11.23-3.74v7.63c0 1.52 1.23 2.75 2.75 2.75h18.5c1.52 0 2.75-1.23 2.75-2.75v-7.63z"></path><path d="m24 7.75v2.29l-11.76 3.92c-.08.03-.16.04-.24.04s-.16-.01-.24-.04l-11.76-3.92v-2.29c0-1.52 1.23-2.75 2.75-2.75h18.5c1.52 0 2.75 1.23 2.75 2.75z"></path></svg>{props.show.data.j_experience} year Expe</span>
                  <span>{kFormatter(props.show.data.j_min_sal)} to {kFormatter(props.show.data.j_max_sal)}</span>
                </span>
                <p class="jblmodal_jobdesc"><strong>job description</strong>{props.show.data.j_description}</p>
                <p><strong>About us</strong>{props.show.data.c_description}</p>
                
                <p><strong>Address </strong>{props.show.data.j_address}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class={props.show.visibility ? "modal-backdrop fade show" : "modal-backdrop fade"}  onClick={() => {document.body.classList.remove("showModal");props.onHide()}}></div>
    </div>
  )
}
const mapStateToProps = (state) => {
  return {joblist: state.list.joblist,allfeild: state.list.allfeild, loginData: state.list.login};
};
const mapDispatchToProps = (dispatch) => {
  return {
    getAlljobs: (old_data, form_data) => dispatch(getAlljobs(old_data, form_data)),
    promise: (id) => dispatch(promise(id))

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DiscriptionJob));
